import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Paper,
  Grid,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import CardPreview from "../components/CardPreview";

const CardsScreen = () => {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  // inside CardView
  const navigate = useNavigate();


  useEffect(() => {
    const fetchCards = async () => {
      try {
        const res = await axios.get("https://fentrixbank.org/api/api/cards", {
          withCredentials: true, // important if using Sanctum
        });
        setCards(res.data);
      } catch (err) {
        console.error("Error fetching cards:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCards();
  }, []);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ pb: 10, px: { xs: 2, md: 4 }, mt: { xs: 2, md: 4 } }}>
      {cards.length > 0 ? (
        <Grid container spacing={2} justifyContent="center">
          {cards.map((card) => (
            <Grid item xs={12} sm={6} md={4} key={card.id}>
              <CardPreview card={card} />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Paper
          sx={{
            Width: "148%",
            mx: "auto",
            mb: "5%",
            mt: { xs: 2, md: 4 },
            p: { xs: 2, md: 3 },
            textAlign: "center",
            borderRadius: 3,
          }}
        >
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Your Cards
          </Typography>

          <Typography variant="body2" color="text.secondary">
            No cards yet
          </Typography>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mt: 1, fontSize: { xs: "0.85rem", md: "0.9rem" } }}
          >
            You haven't applied for any virtual cards yet. Apply for a new card
            to get started with secure online payments.
          </Typography>

          <Button
            variant="contained"
            fullWidth
            sx={{
              mt: 3,
              backgroundColor: "#3b82f6",
              borderRadius: 2,
              px: { xs: 2, md: 3 },
              py: 1,
              textTransform: "none",
              fontSize: { xs: "0.9rem", md: "1rem" },
              "&:hover": { backgroundColor: "#2563eb" },
            }}
            onClick={() => navigate("/card-application")} 
          >
            + Apply for Card
          </Button>
        </Paper>
      )}
    </Box>
  );
};

export default CardsScreen;